<template>
  <rj-drawer title="切换用户身份" placement="left" width="600" v-model="visible" :mask-closable="false" :styles="drawerBodyStytle">
    <iframe v-if="visible" ref="frame" scrolling="no" frameborder="0" :src="frameUrl" style="width: 100%;height: 100%"/>
  </rj-drawer>
</template>
<script type="es6">
import drawer from '../drawer';
export default {
  data () {
    return {
      visible: false,
      drawerBodyStytle: {
        padding: '0',
        overflow: 'hidden',
        backgroundColor: '#fff'
      },
      frameUrl: ''
    };
  },
  components: {
    'rj-drawer': drawer
  },
  computed: {},
  methods: {
    show (opts) {
      this.visible = true;
      this.frameUrl = `${opts.authServe}?jtoken=${opts.jtoken}&systemId=${opts.systemId}`;
      this.addlisten();
    },
    hide () {
      this.visible = false;
    },
    addlisten () {
      let eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
      let eventer = window[eventMethod];
      let messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
      eventer(messageEvent, (ev) => {
        if (ev.data.event_id === 'changUserHander') {
          window.location.href = ev.data.url;
        }
      });
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
</style>
